import { Modal } from "@mui/material";
import "../../../assets/styles/registrationRequest/registrationRequest.scss"

interface ILeadReceiptConfirmationModalProps {
    popUpOpen: boolean;
    setPopUpOpen: (open: boolean) => void;
}

/**
 * Confirmation popup after registration
 */

function RegistrationRequestConfirmationModal({
    popUpOpen,
    setPopUpOpen
}: Readonly<ILeadReceiptConfirmationModalProps>) {
    return (
        <Modal
            className="modal"
            open={popUpOpen}
            onClose={() => {
                setPopUpOpen(false);
            }}
            aria-labelledby="pre-registration-for-anfragen-manager-success-message-label"
            aria-describedby="pre-registration-for-anfragen-manager-success-message-description"
        >
            <div className="modal-body">
                <div
                    className="icon icon-close"
                    role="button"
                    onClick={() => setPopUpOpen(false)}
                ></div>
                <h2 className="highlight-blue">
                    Vielen Dank für Ihr Interesse am Anfragen-Manager!
                </h2>
                <p className="text-black mt-20">
                    <strong>So geht es jetzt weiter:</strong>
                </p>
                <ol className="list">
                    <li>
                        Sie werden innerhalb der nächsten 48 Stunden unter der angegebenen Telefonnummer kontaktiert.
                    </li>
                    <li>
                        Wir stellen Ihnen den Anfragen-Manager vor und beantworten alle Ihre Fragen.
                    </li>
                </ol>
            </div>
        </Modal>
    );
}
export default RegistrationRequestConfirmationModal;
